import getEnabledQuestionsAndSections from '@opsbase/lib-form/helpers/getEnabledQuestionsAndSections';
import doNothing from '@opsbase/lib-general/utils/doNothing';
import Palette from '@opsbase/lib-palette/Palette';
import PerformController from '@opsbase/react-ctrl-perform/PerformController/PerformController';
import useCss from '@opsbase/web-css/useCss/useCss';
import Horizontal from '@opsbase/web-layout/Horizontal/Horizontal';
import Pane from '@opsbase/web-layout/Pane';
import Vertical from '@opsbase/web-layout/Vertical/Vertical';
import OpPerformQuestion from '@opsbase/web-opform-perform/OpPerformQuestion/OpPerformQuestion';
import React from 'react';
const makeMyClasses = () => ({
    root: {
        overflow: 'auto',
        padding: 16,
        background: Palette.WhiteSmoke.main,
        border: `1px solid ${Palette.LavendarGrey.main}`,
    },
    inner: {
        margin: 'auto',
        maxWidth: 640,
    },
    current: {
        minWidth: 400,
        maxWidth: 400,
        height: '100%',
        padding: 16,
        background: Palette.White.main,
        borderLeft: `1px solid ${Palette.LavendarGrey.main}`,
    },
});
export function OpViewAnswers(props) {
    var _a, _b;
    const { op, refs } = props;
    const form = op.getParsedForm();
    const activeQuestionsAndSections = getEnabledQuestionsAndSections(form.questionTree);
    const myCss = useCss(makeMyClasses);
    return (React.createElement(PerformController, { id: op === null || op === void 0 ? void 0 : op.id, title: op === null || op === void 0 ? void 0 : op.title, placeId: (_a = op === null || op === void 0 ? void 0 : op.place) === null || _a === void 0 ? void 0 : _a.id, placeTitle: (_b = op === null || op === void 0 ? void 0 : op.place) === null || _b === void 0 ? void 0 : _b.title, form: form, isSubmitted: true, isScorePublic: op === null || op === void 0 ? void 0 : op.isScorePublic, isScoreEnabled: op === null || op === void 0 ? void 0 : op.isScoreEnabled, isGradingPublic: op === null || op === void 0 ? void 0 : op.isGradingPublic, allowIssuesAndNotes: op === null || op === void 0 ? void 0 : op.allowIssuesAndNotes, gradingMethod: op === null || op === void 0 ? void 0 : op.gradingMethod, selectedQuestionId: '', onChangeSelectedQuestionId: doNothing, alwaysShowScoreWhenEnabled: true, isPreview: true, mode: 'view' },
        React.createElement(Horizontal, { stretch: true, classes: { root: myCss.root } },
            React.createElement(Vertical, { gutter: true, classes: { root: myCss.inner } }, [
                ...activeQuestionsAndSections.map(questionNode => (React.createElement(OpPerformQuestion, { key: questionNode.nodeId, ref: refs[questionNode.questionId], highlightSelected: false, questionNode: questionNode }))),
                React.createElement(Pane, { key: "nothing" },
                    React.createElement("br", null)),
            ]))));
}
export default OpViewAnswers;
